module.exports = __webpack_public_path__ + "img/Paladin-human-m-70.7fde4d25.gif";